import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import AddEditPromptModal from './AddEditPromptModal';
import CallexLoader from '../../../components/CallexLoader';
import Pagination from '../../../components/form/Pagination';
import AdminHeader from '../../../components/header/AdminHeader';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';

import {
  audioPromptsDelete,
  audioPromptsListGet,
  useAudioPromptsList
} from '../../../store/slices/tenantSlices/incomingSlice';
import { checkModulePermission, fileDownload } from '../../../utils/common';
import { useUserRolePermission } from '../../../store/slices/authSlice';
import AudioPlayerModal from '../../../components/Modals/AudioPlayerModal';
import config from '../../../config';

const AudioPrompts = () => {
  const dispatch = useDispatch();
  const audioPromptsList = useAudioPromptsList();
  const userRolePermission = useUserRolePermission();

  const [openAddModal, setOpenAddModal] = useState(false);
  const [audioDetails, setAudioDetails] = useState(null);
  const [editRecord, setEditRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: undefined
  });

  const fetAudioPromptsList = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      const payload = { ...filter };
      await dispatch(audioPromptsListGet(payload)).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  }, 500);

  const deleteAudioPrompts = async () => {
    try {
      const response = await dispatch(audioPromptsDelete(isDeleteId)).unwrap();
      if (response) {
        toast.success('Record deleted successfully');
        if (audioPromptsList?.data?.length === 1) {
          setFilter({ ...filter, page: filter?.page > 1 ? filter.page - 1 : 1 });
        } else {
          fetAudioPromptsList();
        }
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetAudioPromptsList();
  }, [filter]);

  return (
    <div>
      <AdminHeader
        title="Audio Prompts"
        isExpandSearch
        isAdd
        isAddDisabled={!checkModulePermission('is_add', 'Audio Prompts', userRolePermission)}
        onAddClick={() => setOpenAddModal(true)}
        addBtnName="Add Audio Prompts"
        searchPlaceholder="Search Audio Prompts"
        search={filter.search}
        handelSearch={(e) => setFilter({ ...filter, search: e.target.value })}
      />
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          <CallexLoader />
        </Card>
      ) : audioPromptsList?.data?.length > 0 &&
        checkModulePermission('is_view', 'Audio Prompts', userRolePermission) ? (
        <Card className="p-0 position-relative m-0">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 210px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th className="text-center" style={{ width: '90px' }}>
                    Prompt
                  </th>
                  <th>Name</th>
                  <th className="text-center" style={{ width: '90px' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {audioPromptsList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center cursor-pointer">
                        <div className="d-flex justify-content-around align-items-center gap-2">
                          <Icon.PlayCircle
                            size={16}
                            onClick={() =>
                              setAudioDetails({
                                ...val,
                                src: `${config.BASE_URL}cdrs_report/download?filename=${val.full_file_path}`
                              })
                            }
                            className="cursor-pointer text-info"
                          />
                          <Icon.Download
                            size={16}
                            onClick={() => {
                              fileDownload(
                                `${config.BASE_URL}cdrs_report/download?filename=${val.full_file_path}`
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>{val?.name}</td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          {/* <div className="cursor-pointer text-info">
                          <Icon.Edit
                            size={16}
                            onClick={() => {
                              setEditRecord(val);
                              setIsEdit(true);
                              setOpenAddModal(true);
                            }}
                          />
                        </div> */}
                          <div
                            className={`cursor-pointer text-danger ${
                              !checkModulePermission(
                                'is_delete',
                                'Audio Prompts',
                                userRolePermission
                              )
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Trash
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission(
                                    'is_delete',
                                    'Audio Prompts',
                                    userRolePermission
                                  )
                                ) {
                                  setIsDeleteId(val?.id);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="position-absolute w-100" style={{ bottom: '-56px' }}>
            <Pagination
              totalCount={audioPromptsList?.total}
              limit={audioPromptsList?.limit}
              page={audioPromptsList?.page}
              onLimitChange={(val) => {
                setFilter({ ...filter, page: 1, limit: val });
              }}
              onPageClick={(val) => setFilter({ ...filter, page: val })}
              lastPageClick={(val) => setFilter({ ...filter, page: val })}
              firstPageClick={(val) => setFilter({ ...filter, page: val })}
              onRefreshClick={() => fetAudioPromptsList()}
            />
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          No data available
        </Card>
      )}
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => deleteAudioPrompts()}
      />
      <AddEditPromptModal
        isOpen={openAddModal}
        onCloseClick={(apiCall = false) => {
          setOpenAddModal(false);
          setEditRecord(null);
          setIsEdit(false);
          if (apiCall) {
            fetAudioPromptsList();
          }
        }}
        editRecord={editRecord}
        isEdit={isEdit}
      />
      {audioDetails && (
        <AudioPlayerModal
          modalOpen={!!audioDetails}
          handleClose={() => setAudioDetails(null)}
          details={audioDetails}
        />
      )}
    </div>
  );
};

export default AudioPrompts;
